module.exports = __webpack_public_path__ + "static/media/YM43_6.4e9f13be.jpg";